export default __webpack_public_path__ + "static/media/coach_tabby.fc49048e.png";